import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFilePdf.tsx
const IconFilePdf = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#fc6060",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm.55 6.094v-4.188h1.98q.294 0 .528.102.234.096.396.27.168.174.258.426.09.246.09.54 0 .3-.09.546t-.258.42q-.162.174-.396.276a1.4 1.4 0 0 1-.528.096h-1.068v1.512zm.912-2.304h.96a.46.46 0 0 0 .318-.102q.12-.108.12-.312v-.264q0-.204-.12-.306a.44.44 0 0 0-.318-.108h-.96zm3.026-1.884h1.578q.414 0 .756.132t.582.396q.24.258.372.654.132.39.132.912t-.132.918a1.8 1.8 0 0 1-.372.654q-.24.258-.582.39t-.756.132h-1.578zm1.578 3.378q.408 0 .642-.228t.234-.732v-.648q0-.504-.234-.732t-.642-.228H15.4v2.568zm5.383-3.378h-2.778v4.188h.912v-1.716h1.59v-.804h-1.59v-.858h1.866z",
			clipRule: "evenodd"
		})
	]
});
var IconFilePdf_default = forwardRef(IconFilePdf);
//#endregion
export { IconFilePdf_default as default };
